export const services = {
  // Airport Transfers
  airportTransfers: 'Transferts Aéroport',
  airportTransfersDesc: 'Service de navette premium depuis et vers tous les aéroports du Maroc et du Canada.',
  airportTransfersFeatures: [
    'Ponctualité garantie',
    'Véhicules climatisés',
    'Chauffeurs professionnels'
  ],
  airportTransfersDetailDesc: 'Notre service de transfert aéroport vous garantit un voyage confortable et sans stress. Nos chauffeurs professionnels vous accueillent avec un panneau nominatif et s\'occupent de vos bagages.',
  airportTransfersIncluded: [
    'Suivi de vol en temps réel',
    'Véhicules Mercedes et BMW récents',
    'Eau et rafraîchissements à bord',
    'WiFi gratuit dans tous les véhicules',
    'Service de conciergerie',
    'Assistance 24h/24'
  ],
  airports: ['Mohammed V - Casablanca', 'Marrakech Menara', 'Agadir Al Massira', 'Fès Saïs', 'Montréal-Trudeau', 'Toronto Pearson'],
  
  // Tourist Circuits
  touristCircuits: 'Circuits Touristiques',
  touristCircuitsDesc: 'Explorez les merveilles du Maroc avec nos circuits personnalisés et guides experts.',
  touristCircuitsFeatures: [
    'Itinéraires sur mesure',
    'Guides multilingues',
    'Découvertes authentiques'
  ],
  touristCircuitsDetailDesc: 'Découvrez le Maroc authentique avec nos circuits sur mesure. De la médina de Fès aux dunes de Merzouga, chaque itinéraire est conçu pour vous offrir une expérience inoubliable.',
  touristCircuitsIncluded: [
    'Guide certifié multilingue',
    'Véhicule 4x4 climatisé',
    'Hébergement en riads et camps berbères',
    'Repas traditionnels inclus',
    'Activités culturelles',
    'Photos professionnelles'
  ],
  destinations: ['Désert de Merzouga', 'Vallée du Dadès', 'Aït Benhaddou', 'Chefchaouen', 'Essaouira', 'Atlas Mountains'],
  
  // Crew Transport
  crewTransport: 'Service de transport pour équipages aérien',
  crewTransportDesc: 'Service spécialisé pour les équipages de cabine (cabin crew) et personnel navigant.',
  crewTransportFeatures: [
    'Transport cabin crew',
    'Horaires flexibles',
    'Service professionnel'
  ],
  crewTransportDetailDesc: 'Notre service spécialisé s\'adresse aux équipages de cabine (cabin crew) et au personnel navigant. Nous comprenons les contraintes horaires et les besoins spécifiques du secteur aérien.',
  crewTransportIncluded: [
    'Transport adapté aux horaires de vol',
    'Véhicules confortables pour le repos',
    'Service 24h/24 pour tous les créneaux',
    'Chauffeurs formés aux besoins cabin crew',
    'Suivi des horaires de vol en temps réel',
    'Tarifs préférentiels pour compagnies aériennes'
  ],
  occasions: ['Équipages en escale', 'Personnel navigant', 'Cabin crew en repos', 'Transferts hôtel-aéroport', 'Services compagnies aériennes'],
  
  // Day Excursions
  dayExcursions: 'Excursions',
  dayExcursionsDesc: 'Découvrez les sites emblématiques lors d\'excursions inoubliables.',
  dayExcursionsFeatures: [
    'Départ matinal',
    'Sites incontournables',
    'Retour confortable'
  ],
  dayExcursionsDetailDesc: 'Parfait pour découvrir les trésors du Maroc. Nos excursions combinent sites historiques, paysages naturels et expériences culturelles authentiques.',
  dayExcursionsIncluded: [
    'Transport aller-retour',
    'Guide local expérimenté',
    'Déjeuner traditionnel',
    'Entrées aux sites touristiques',
    'Pause thé à la menthe',
    'Temps libre pour shopping'
  ],
  dayDestinations: ['Cascades d\'Ouzoud', 'Vallée de l\'Ourika', 'Essaouira', 'Aït Benhaddou', 'Imlil', 'Ouarzazate'],
  
  // Chauffeur Service
  chauffeurService: 'Location avec Chauffeur',
  chauffeurServiceDesc: 'Véhicules premium avec chauffeurs expérimentés pour vos déplacements libres.',
  chauffeurServiceFeatures: [
    'Flexibilité totale',
    'Tarifs transparents',
    'Disponibilité 24h/7j'
  ],
  chauffeurServiceDetailDesc: 'Louez un véhicule avec chauffeur pour une liberté totale dans vos déplacements. Idéal pour les séjours prolongés ou les voyages d\'affaires.',
  chauffeurServiceIncluded: [
    'Véhicule récent et entretenu',
    'Chauffeur professionnel bilingue',
    'Carburant inclus',
    'Assurance tous risques',
    'Assistance routière 24h/24',
    'Nettoyage quotidien du véhicule'
  ],
  vehicles: ['Berlines confort', 'SUV 7 places', 'Minibus 15 places', 'Véhicules de luxe'],
  
  // Canada Services
  canadaServices: 'Services Canada',
  canadaServicesDesc: 'Extension de nos services premium au Canada pour vos voyages nord-américains.',
  canadaServicesFeatures: [
    'Montréal & Toronto',
    'Circuits hivernaux',
    'Expérience canadienne'
  ],
  canadaServicesDetailDesc: 'Découvrez le Canada avec le même niveau de service premium. Nos partenaires locaux vous offrent une expérience authentique dans les plus belles villes canadiennes.',
  canadaServicesIncluded: [
    'Véhicules adaptés au climat canadien',
    'Guides francophones natifs',
    'Circuits urbains et nature',
    'Expériences hivernales uniques',
    'Hébergement en hôtels boutique',
    'Spécialités culinaires locales'
  ],
  cities: ['Montréal', 'Toronto', 'Québec', 'Ottawa', 'Niagara Falls', 'Mont-Tremblant']
};